import React, {Component} from 'react'
import {Input, message} from 'antd'
import {unmarkPrinted} from "../../services/api/3dApi"

class MarkUnprintedPage extends Component {
    state = {
        inputValue: '',
    }

    _timeOut = null
    _input = React.createRef()

    _handleChange = e => {
        const {value} = e.target

        this.setState({
            inputValue: value,
        })

        const valueFormatted = value.trim().replace(/^#/, '')

        if (!valueFormatted) {
            return null
        }

        if (this._timeOut) clearTimeout(this._timeOut)

        this._timeOut = setTimeout(() => {
            this._rqPrintAction(valueFormatted)
        }, 500)
    }

    _rqPrintAction = async (value) => {
        try {
            const {data: response} = await unmarkPrinted(value)

            const {success, error} = response

            if (!success) {
                throw new Error(error)
            }

            this.setState({
                inputValue: '',
            })

            message.success('Order submitted')

        } catch (e) {
            message.error(e.message, 3)
        } finally {
            this._input.current.focus()
        }
    }

    render() {
        const {inputValue} = this.state

        return (
            <div className='MarkUnprintedPage p-5'>
                <div className='row'>
                    <div className='col-8 mx-auto'>
                        <h1>Đánh dấu chưa in</h1>
                        <Input onChange={this._handleChange} value={inputValue} size='large' ref={this._input}/>
                    </div>
                </div>
            </div>
        )
    }
}

export default MarkUnprintedPage
